import React from 'react'
import { useWindowSize } from "@uidotdev/usehooks";

const ContextoDispositivo = React.createContext()

const ProveedorDispositivo = ({ children }) => {
    const size = useWindowSize()
    const dispositivo = size.width > 600
    return (
        <ContextoDispositivo.Provider value={{ dispositivo }}>
            {children}
        </ContextoDispositivo.Provider>
    );
}

export { ProveedorDispositivo, ContextoDispositivo };